
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/sattvic-store",
      function () {
        return require("private-next-pages/case-study/sattvic-store.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/sattvic-store"])
      });
    }
  